import { useMemo } from 'react';

import { getTableOptions } from '../utils/tableOptions';

export const useTableOptions = () => {
	return useMemo(() => getTableOptions(), []);
};
